import { TDevice } from '@/types/Device'
import { Device } from '@capacitor/device'
import { Logger } from '@/lib/logger'

const logger = new Logger('getDevice')

export const getDevice = async (): Promise<TDevice | null> => {
  try {
    const [info, id] = await Promise.all([Device.getInfo(), Device.getId()])

    return {
      platform: info.platform,
      deviceId: id.identifier,
      model: info.model,
      osVersion: info.osVersion,
    }
  } catch (error) {
    logger.error('Erro ao obter informações do dispositivo:', error)
    return null
  }
}
